import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const CodeSnippet = ({ code, language = 'bash', className = '' }) => {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={`relative group rounded-lg border border-signal/10 bg-obsidian ${className}`}>
      <div className="flex items-center justify-between px-4 py-2 border-b border-signal/5">
        <span className="font-mono text-[10px] text-steel-muted uppercase tracking-wider">{language}</span>
        <button
          onClick={copy}
          className="flex items-center gap-1 text-steel-muted hover:text-cyan transition-colors duration-fast text-xs font-mono"
          aria-label="Copy code"
        >
          {copied ? <><Check className="w-3.5 h-3.5" /> Copied</> : <><Copy className="w-3.5 h-3.5" /> Copy</>}
        </button>
      </div>
      <pre className="p-4 overflow-x-auto">
        <code className="font-mono text-sm text-cyan/90 leading-relaxed">{code}</code>
      </pre>
    </div>
  );
};

export default CodeSnippet;
